(() => {
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const T = window.theme || { routes: {} }, R = T.routes;
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const formatMoney = cents => {
    const fmt = T.moneyFormat || '${{amount}}', n = cents / 100;
    const num = (dec, th = ',', d = '.') => { const [a, b] = n.toFixed(dec).split('.'); return a.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (b ? d + b : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) =>
      k === 'amount_no_decimals' ? num(0) : k === 'amount_with_comma_separator' ? num(2, '.', ',') :
      k === 'amount_no_decimals_with_comma_separator' ? num(0, '.', ',') : num(2));
  };
  const toast = msg => {
    const t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(toast.t); toast.t = setTimeout(() => t.classList.remove('on'), 1800);
  };

  // ---------- announcement bar ----------
  const ann = () => {
    const items = $$('.ann-track a'); let i = 0;
    if (items.length < 2) return;
    const go = d => { items[i].classList.remove('on'); i = (i + d + items.length) % items.length; items[i].classList.add('on'); };
    $$('.ann-btn').forEach(b => b.onclick = () => go(+b.dataset.dir));
    if (!reduceMotion) setInterval(() => go(1), 4500);
  };
  ann();

  // ---------- rails, progress bars, counters, tabs ----------
  const arrows = rail => {
    const wrap = rail.parentElement, l = $('.rail-arrow.l', wrap), r = $('.rail-arrow.r', wrap);
    if (!l) return;
    l.disabled = rail.scrollLeft < 4;
    r.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
  };
  const initRails = (root = document) => {
    $$('.rail-arrow', root).forEach(b => b.onclick = () => {
      const rail = document.getElementById(b.dataset.rail), c = rail && rail.firstElementChild;
      if (c) rail.scrollBy({ left: +b.dataset.dir * (c.offsetWidth + 16) });
    });
    $$('.rail', root).forEach(r => {
      const bar = r.closest('.cp-rail')?.querySelector('.rail-progress');
      const fill = bar && $('i', bar);
      const upd = () => {
        arrows(r);
        if (!fill) return;
        const max = r.scrollWidth - r.clientWidth;
        bar.hidden = max <= 4;
        fill.style.width = (max > 0 ? (r.scrollLeft + r.clientWidth) / (r.scrollWidth || 1) : 1) * 100 + '%';
      };
      r.addEventListener('scroll', upd, { passive: true });
      addEventListener('resize', upd);
      upd();
    });
    $$('.clt-rail', root).forEach(r => {
      const bar = $('.clt-bar i', r.closest('.coll')); if (!bar) return;
      const upd = () => {
        const w = r.clientWidth / (r.scrollWidth || 1);
        bar.style.width = w * 100 + '%'; bar.style.left = r.scrollLeft / (r.scrollWidth || 1) * 100 + '%';
        bar.parentElement.hidden = w >= 0.99;
      };
      r.addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd); upd();
    });
    $$('[data-count-rail]', root).forEach(r => {
      const n = $('[data-n]', r.closest('.tab-panel')); if (!n) return;
      r.addEventListener('scroll', () => {
        const c = r.firstElementChild; if (!c) return;
        n.textContent = Math.min(r.children.length, Math.round(r.scrollLeft / (c.offsetWidth + 16)) + 1);
      }, { passive: true });
    });
    $$('[data-tabs]', root).forEach(sec => {
      const tabs = $$('[role=tab]', sec);
      tabs.forEach(t => t.onclick = () => {
        tabs.forEach(x => { const on = x === t; x.classList.toggle('on', on); x.setAttribute('aria-selected', on); document.getElementById(x.getAttribute('aria-controls')).hidden = !on; });
        $$('.rail', document.getElementById(t.getAttribute('aria-controls'))).forEach(arrows);
      });
    });
  };
  initRails();
  addEventListener('resize', () => $$('.rail').forEach(arrows));
  document.addEventListener('shopify:section:load', e => initRails(e.target));

  // ---------- drawers + search overlay ----------
  const scrim = $('#scrim');
  let lastFocus = null;
  const openerOf = el => ({ menu: '#openMenu', cart: '#openCart' }[el.id]);
  const openPanel = el => {
    if (!el || el.classList.contains('on')) return;
    lastFocus = document.activeElement;
    el.classList.add('on'); el.setAttribute('aria-hidden', 'false');
    const o = openerOf(el); if (o && $(o)) $(o).setAttribute('aria-expanded', 'true');
    if (el.classList.contains('drawer')) scrim.classList.add('on');
    document.body.style.overflow = 'hidden';
    setTimeout(() => ($('input[type=search]', el) || $('[data-close]', el))?.focus(), 50);
  };
  const closeAll = () => {
    $$('.drawer.on, .search.on').forEach(el => {
      el.classList.remove('on'); el.setAttribute('aria-hidden', 'true');
      const o = openerOf(el); if (o && $(o)) $(o).setAttribute('aria-expanded', 'false');
    });
    scrim?.classList.remove('on'); document.body.style.overflow = '';
    lastFocus?.focus();
  };
  const cartDrawer = () => $('#cart');
  const onCartPage = document.body.classList.contains('template-cart');
  $('#openMenu')?.addEventListener('click', () => openPanel($('#menu')));
  $('#openCart')?.addEventListener('click', e => { if (cartDrawer() && !onCartPage) { e.preventDefault(); openPanel(cartDrawer()); } });
  scrim?.addEventListener('click', closeAll);
  document.addEventListener('click', e => { if (e.target.closest('[data-close]')) closeAll(); });
  $$('.menu-nav a').forEach(a => a.addEventListener('click', closeAll));
  addEventListener('keydown', e => {
    if (e.key === 'Escape') closeAll();
    const open = $('.drawer.on, .search.on');
    if (e.key === 'Tab' && open) {
      const f = $$('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea', open).filter(x => x.offsetParent !== null);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      else if (!open.contains(document.activeElement)) { e.preventDefault(); f[0].focus(); }
    }
    if (e.key === '/' && !/INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)) { e.preventDefault(); openSearch(); }
  });

  // predictive search (Shopify /search/suggest + section rendering)
  const sEl = $('#search'), sq = $('#sq'), sres = $('#sres');
  const showEmpty = () => { if (sres && $('#search-empty')) sres.innerHTML = $('#search-empty').innerHTML; };
  let ctrl, timer;
  const runSearch = () => {
    const q = sq.value.trim();
    if (!q) return showEmpty();
    ctrl?.abort(); ctrl = new AbortController();
    fetch(`${R.predictive}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&section_id=predictive-search`, { signal: ctrl.signal })
      .then(r => r.text())
      .then(html => {
        const box = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-predictive]');
        sres.innerHTML = !box || box.querySelector('[data-none]')
          ? `<div class="search-hint">No results for "${q.replace(/[<>&"]/g, '')}". Try a bike name like Tuttio or a part like brakes.</div>`
          : box.innerHTML;
      }).catch(() => {});
  };
  function openSearch() { if (!sEl) return; openPanel(sEl); sq.value ? runSearch() : showEmpty(); }
  $('#openSearch')?.addEventListener('click', e => { if (sEl) { e.preventDefault(); openSearch(); } });
  sq?.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(runSearch, 180); });
  sres?.addEventListener('click', e => { const b = e.target.closest('[data-s]'); if (b) { sq.value = b.dataset.s; runSearch(); sq.focus(); } });
  $('form', sEl || document.createElement('div'))?.addEventListener('submit', e => { if (!sq.value.trim()) e.preventDefault(); });

  // ---------- cart (AJAX API + section rendering) ----------
  const sectionIdOf = el => el?.closest('.shopify-section')?.id.replace('shopify-section-', '');
  const pageSection = () => sectionIdOf($('[data-cart-page]'));
  const setCount = n => $$('[data-cart-count]').forEach(e => e.textContent = n);
  const swap = (html, sel) => {
    if (!html) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(sel), old = $(sel);
    if (fresh && old) old.replaceWith(fresh);
  };
  const cartPost = async (url, body) => {
    const sections = ['cart-drawer', pageSection()].filter(Boolean);
    const r = await fetch(url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: sections.join(','), sections_url: location.pathname })
    });
    const j = await r.json();
    if (!r.ok || j.status) throw new Error(j.description || j.message || 'Could not update the cart');
    swap(j.sections?.['cart-drawer'], '#cart .drawer-inner');
    if (pageSection()) swap(j.sections?.[pageSection()], '[data-cart-page]');
    const cart = await fetch(R.cart + '.js').then(x => x.json());
    setCount(cart.item_count);
    return cart;
  };
  const addItems = async (items, open = true) => {
    await cartPost(R.cartAdd, { items });
    toast('Added to cart');
    if (open && cartDrawer() && !onCartPage) openPanel(cartDrawer());
  };

  document.addEventListener('click', async e => {
    const add = e.target.closest('button[data-variant-id]');
    if (add) {
      add.disabled = true;
      try { await addItems([{ id: +add.dataset.variantId, quantity: 1 }]); }
      catch (err) { toast(err.message.length < 46 ? err.message : 'Unavailable'); }
      add.disabled = false;
      return;
    }
    const line = e.target.closest('[data-line-key]');
    if (line) {
      line.disabled = true;
      try { await cartPost(R.cartChange, { id: line.dataset.lineKey, quantity: Math.max(0, +line.dataset.lineQty) }); }
      catch (err) { toast(err.message); line.disabled = false; }
    }
  });

  // ---------- product page ----------
  $$('[data-pdp]').forEach(pdp => {
    const data = JSON.parse($('[data-product-json]', pdp).textContent);
    const form = $('[data-product-form]', pdp), idIn = $('[name=id]', form), btn = $('[data-add-btn]', pdp);
    const qtyIn = $('[data-qty-input]', pdp), err = $('[data-form-error]', pdp);
    const priceBox = $('[data-price]', pdp), now = $('[data-price-now]', pdp), was = $('[data-price-was]', pdp), save = $('[data-price-save]', pdp);
    const sticky = $('#stickyAtc');
    let variant = data.variants.find(v => v.id === +idIn.value) || data.variants[0];
    const selected = () => $$('[data-option-index]', pdp).map(box => ($('input:checked', box) || $('select', box))?.value);
    const setMain = (src, id) => {
      const img = $('#gMain'); if (img && src) { img.removeAttribute('srcset'); img.src = src; }
      $$('.g-thumbs button', pdp).forEach(t => t.classList.toggle('on', String(t.dataset.mediaId) === String(id)));
    };
    const paint = () => {
      const q = Math.max(1, +qtyIn.value || 1);
      $$('[data-option-index]', pdp).forEach((box, i) => { const l = $('[data-ol]', box); if (l) l.textContent = selected()[i]; });
      if (!variant) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idIn.value = variant.id;
      const sale = variant.compare_at_price > variant.price;
      now.textContent = formatMoney(variant.price);
      priceBox.classList.toggle('sale', sale);
      was.hidden = save.hidden = !sale;
      if (sale) { was.textContent = formatMoney(variant.compare_at_price); save.textContent = `SAVE ${Math.round((1 - variant.price / variant.compare_at_price) * 100)}%`; }
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? `Add to cart · ${formatMoney(variant.price * q)}` : 'Sold out';
      const sp = $('[data-sticky-price]'); if (sp) sp.textContent = formatMoney(variant.price);
      $$('[data-fbt-main]').forEach(c => c.dataset.price = variant.price);
      fbtPaint();
    };
    $$('[data-option-index] input, [data-option-index] select', pdp).forEach(i => i.addEventListener('change', () => {
      const sel = selected();
      variant = data.variants.find(v => v.options.every((o, k) => o === sel[k]));
      if (variant?.featured_media) setMain(variant.featured_media.preview_image?.src, variant.featured_media.id);
      if (variant) history.replaceState(null, '', `${location.pathname}?variant=${variant.id}`);
      paint();
    }));
    $$('[data-qty-step]', pdp).forEach(b => b.onclick = () => { qtyIn.value = Math.max(1, (+qtyIn.value || 1) + +b.dataset.qtyStep); paint(); });
    qtyIn.addEventListener('input', paint);
    $$('.g-thumbs button', pdp).forEach(b => b.onclick = () => setMain(b.dataset.src, b.dataset.mediaId));
    form.addEventListener('submit', async e => {
      if (!cartDrawer()) return; // no drawer: normal form post to /cart/add
      e.preventDefault();
      err.hidden = true; btn.disabled = true;
      try { await addItems([{ id: +idIn.value, quantity: Math.max(1, +qtyIn.value || 1) }]); qtyIn.value = 1; }
      catch (x) { err.hidden = false; err.textContent = x.message; }
      paint();
    });
    if (sticky) {
      $('[data-sticky-add]', sticky).onclick = () => form.requestSubmit ? form.requestSubmit() : btn.click();
      new IntersectionObserver(([e]) => sticky.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(btn);
    }
    paint();
  });

  // frequently bought together
  function fbtPaint() {
    $$('[data-fbt]').forEach(box => {
      const checked = $$('input[type=checkbox]', box).filter(c => c.checked);
      $('[data-fbt-total]', box).textContent = formatMoney(checked.reduce((a, c) => a + +c.dataset.price, 0));
      $('[data-fbt-add]', box).textContent = checked.length > 1 ? `Add all ${checked.length} to cart` : 'Add to cart';
    });
  }
  $$('[data-fbt]').forEach(box => {
    $$('input[type=checkbox]', box).forEach(c => c.onchange = fbtPaint);
    $('[data-fbt-add]', box).onclick = async () => {
      const main = $('[data-pdp] [name=id]'), qty = 1;
      const items = [{ id: +main.value, quantity: qty }, ...$$('[data-fbt-id]', box).filter(c => c.checked).map(c => ({ id: +c.dataset.fbtId, quantity: 1 }))];
      try { await addItems(items); } catch (x) { toast(x.message); }
    };
  });
  fbtPaint();

  // product recommendations (lazy, section rendering)
  $$('[data-recs]').forEach(el => {
    if (el.children.length) return;
    fetch(el.dataset.url).then(r => r.text()).then(html => {
      const box = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recs]');
      if (box && box.innerHTML.trim()) { el.innerHTML = box.innerHTML; initRails(el); }
    }).catch(() => {});
  });

  // ---------- collection filters: submit on change, drop empty params ----------
  $$('[data-filter-form]').forEach(f => {
    const go = () => {
      const p = new URLSearchParams(new FormData(f));
      [...p.keys()].forEach(k => { if (!p.get(k)) p.delete(k); });
      location.search = p.toString();
    };
    f.addEventListener('change', e => { if (e.target.type !== 'number') go(); });
    f.addEventListener('submit', e => { e.preventDefault(); go(); });
    document.addEventListener('click', e => $$('.ch-dd[open]', f).forEach(d => { if (!d.contains(e.target)) d.open = false; }));
  });

})();
